import colors from '../../colors.json'
import Metrics from '../Metrics'
import { BoxSizes, Chart, Dashboard } from './types'

const LiftAndLearn: Dashboard = {
    id: 'LIFTLEARN',
    name: 'Lift & Learn',
    daterange: true,
    metrics: [
        {
            type: Metrics.LIFTLEARN_DWELLTIMELINE,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            color: '#2f9b8f',
            title: 'dashboard-dwelltimeline',
            count: 'dashboard-count-seconds-average',
        },
        {
            type: Metrics.LIFTLEARN_DWELLTIMELINE_PRODUCTS,
            'box-size': BoxSizes.BIG,
            chart: Chart.Timeline,
            color: [colors.bluelight, colors.orange, '#bb5ee0', '#56bbc5'],
            legend: true,
            title: 'dashboard-dwelltimeline-products',
            count: 'dashboard-count-products',
        },
        {
            type: Metrics.GROUP,
            'box-size': BoxSizes.THIRD,
            metrics: [
                {
                    type: Metrics.LIFTLEARN_TOTAL_INTERACTIONS,
                    'box-size': BoxSizes.BIG,
                    title: 'dashboard-interactions-total',
                },
                {
                    type: Metrics.LIFTLEARN_DWELLTIME_TOTAL,
                    'box-size': BoxSizes.BIG,
                    color: '#2f9b8f',
                    title: 'dashboard-liftlearn-dwelltime-total',
                },
                {
                    type: Metrics.LIFTLEARN_DWELLTIME_TOTAL_PRODUCTS,
                    'box-size': BoxSizes.FULLWIDTH,
                    color: [colors.bluelight, colors.orange, '#bb5ee0', '#56bbc5'],
                    title: 'dashboard-liftlearn-dwelltime-product',
                    count: 'dashboard-count-products',
                },
            ],
        },
        {
            type: Metrics.LIFTLEARN_DWELLTIME_AVERAGE,
            'box-size': BoxSizes.SIXTH,
            color: '#2f9b8f',
            title: 'dashboard-liftlearn-dwelltime-average',
        },
        {
            type: Metrics.LIFTLEARN_DWELLTIME_BOUNCERATE,
            'box-size': BoxSizes.SIXTH,
            title: 'dashboard-liftlearn-bouncerate',
        },
        {
            type: Metrics.LIFTLEARN_TOP_STORES,
            'box-size': BoxSizes.SIXTH,
            chart: Chart.List,
            count: 'dashboard-count-stores',
            title: 'dashboard-stores-top',
        },
        {
            type: Metrics.LIFTLEARN_TOP_PRODUCTS,
            'box-size': BoxSizes.SIXTH,
            chart: Chart.List,
            count: 'dashboard-count-products',
            title: 'dashboard-liftlearn-top-products',
        },
    ],
}

export default LiftAndLearn
